<vp-loading-screen *ngIf="auth.isLoggedIn"></vp-loading-screen>
<div *ngIf="!auth.isLoggedIn && ctx.msTeams">
        <br/>
        <h2 class="titles">{{ 'login.title' | translate }}</h2>
        <br/>
        <button class="buttons" (click)="logInFromTeams()" type="button">
                {{ 'common.logIn' | translate }}
        </button>
</div>
